import { Component, inject, Inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogActions,
  MatDialogContent,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import { MedicamentosService } from '../../../core/services/medicamentos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-medicamentos',
  imports: [
    MatStepperModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogActions,
    MatDialogContent,
  ],
  templateUrl: './medicamentos.html',
  styleUrl: './medicamentos.scss',
})
export class Medicamentos {
  constructor(
    private dialogRef: MatDialogRef<Medicamentos>,
    private medicamentosService: MedicamentosService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  private fb = inject(FormBuilder);

  form = this.fb.group({
    medicamento: [''],
    dosis: [''],
    frecuencia: [''],
    duracion: [''],
    administracion: [''],
    idReceta: [null as number | null],
  });

  ngOnInit(): void {
    // Si existe medicamento, significa que estamos EDITANDO
    if (this.data?.medicamento) {
      this.form.patchValue({
        medicamento: this.data.medicamento.medicamento,
        dosis: this.data.medicamento.dosis,
        frecuencia: this.data.medicamento.frecuencia,
        duracion: this.data.medicamento.duracion,
        administracion: this.data.medicamento.administracion,
        // idReceta: this.data.medicamento.idReceta,
      });
      return;
    }
    this.form.patchValue({
      idReceta: this.data?.idReceta ?? null,
    });

    // console.log('ID RECETA RECIBIDO:', this.data?.idReceta);
  }

  cerrar() {
    this.dialogRef.close();
  }

  guardar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const valores = this.form.getRawValue();

    const idReceta = valores.idReceta ?? this.data?.idReceta;

    if (!idReceta) {
      // console.error('No existe idReceta.');
      // console.error('Data recibida:', this.data);
      // console.error('Valores del formulario:', valores);

      Swal.fire({
        icon: 'error',
        title: 'Receta no disponible',
        text: 'No se encontró el ID de la receta. Primero debes crear la receta.',
        showConfirmButton: false,
        timer: 2000,
      });

      return;
    }

    const payload: any = {
      medicamento: valores.medicamento,
      dosis: valores.dosis,
      frecuencia: valores.frecuencia,
      duracion: valores.duracion,
      administracion: valores.administracion,
    };

    // console.log('VALORES DEL FORMULARIO:', valores);
    // console.log('PAYLOAD ENVIADO:', payload);

    // ============================================
    // EDITAR INDICACIÓN
    // ============================================
    if (this.data?.medicamento?.id) {
      const id = this.data.medicamento.id;

      // console.log('EDITANDO INDICACIÓN:', id);

      this.medicamentosService.actualizarMedicamento(id, payload).subscribe({
        next: (respuesta) => {
          Swal.fire({
            icon: 'success',
            title: 'Medicamento actualizado',
            text: 'El medicamento fue actualizado correctamente.',
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            // console.log('Respuesta del backend:', respuesta);

            this.dialogRef.close(respuesta?.data ?? respuesta);
          });
        },

        error: (error) => {
          // console.error('Error al actualizar el medicamento:', error);

          Swal.fire({
            icon: 'error',
            title: 'No se pudo actualizar',
            text: error?.error?.message ?? 'Ocurrió un error al actualizar el medicamento.',
            showConfirmButton: false,
            timer: 2000,
          });
        },
      });

      return;
    }

    // ============================================
    // CREAR INDICACIÓN
    // ============================================

    // console.log('CREANDO NUEVO MEDICAMENTO');

    payload['idReceta'] = Number(idReceta);

    this.medicamentosService.crearMedicamento(payload).subscribe({
      next: (respuesta) => {
        Swal.fire({
          icon: 'success',
          title: 'Registro exitoso',
          text: 'La nuevo medicamento fue agregada correctamente.',
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          // console.log('Respuesta del backend:', respuesta);

          this.dialogRef.close(respuesta?.data ?? respuesta);
        });
      },

      error: (error) => {
        // console.error('Error al agregar el nuevo medicamento:', error);

        Swal.fire({
          icon: 'error',
          title: 'No se pudo agregar',
          text: error?.error?.message ?? 'Ocurrió un error al guardar el nuevo medicamento.',
          showConfirmButton: false,
          timer: 2000,
        });
      },
    });
  }
}
